import { render, staticRenderFns } from "./inquiryNot.vue?vue&type=template&id=37d7d51c&scoped=true"
import script from "./inquiryNot.vue?vue&type=script&lang=js"
export * from "./inquiryNot.vue?vue&type=script&lang=js"
import style0 from "../scss/index.scss?vue&type=style&index=0&id=37d7d51c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d7d51c",
  null
  
)

export default component.exports